import type { CategoryStat } from "@/services/wholesale-analytics";
import { cn } from "@/lib/utils";
import { fmtKm } from "@/lib/wholesale-format";
import { Section, TH, THEAD_ROW, Delta, SellThroughBar, ShareBar, fmtInt } from "./parts";

export function CategoriesSection({ categories, compare }: { categories: CategoryStat[]; compare: boolean }) {
  const current = categories.filter((c) => c.units > 0);
  const gone = categories.filter((c) => c.units === 0);
  const maxShare = current[0]?.share ?? 0;
  return (
    <Section
      title="Kategorije"
      hint="Artikal u više kategorija računa se u svakoj, pa zbir kategorija može biti veći od ukupnog prometa."
    >
      {categories.length === 0 ? (
        <p className="px-3 py-6 text-center text-xs text-muted-foreground">Nema prodaje po kategorijama u ovom periodu.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-xs">
            <thead>
              <tr className={THEAD_ROW}>
                <th className={`${TH} pl-3 text-left`}>Kategorija</th>
                <th className={`${TH} text-left w-44 hidden md:table-cell`}>Udio</th>
                <th className={`${TH} text-right`}>Promet</th>
                {compare && <th className={`${TH} text-right hidden sm:table-cell`}>Promjena</th>}
                <th className={`${TH} text-right hidden sm:table-cell`}>Kom.</th>
                <th className={`${TH} text-right hidden md:table-cell`}>Artikala</th>
                <th className={`${TH} pr-3 text-right`}>Sell-through</th>
              </tr>
            </thead>
            <tbody>
              {[...current, ...gone].map((c) => (
                <tr key={c.slug || "__none__"} className={cn("border-b last:border-b-0 hover:bg-muted/30 transition-colors", c.units === 0 && "text-muted-foreground")}>
                  <td className={cn("py-2.5 px-2 pl-3 font-medium max-w-[14rem] truncate", !c.slug && "italic font-normal")}>{c.name}</td>
                  <td className="py-2.5 px-2 hidden md:table-cell">{c.units > 0 && <ShareBar value={c.share} max={maxShare} />}</td>
                  <td className="py-2.5 px-2 text-right tabular-nums font-medium whitespace-nowrap">{fmtKm(c.revenue)}</td>
                  {compare && (
                    <td className="py-2.5 px-2 text-right hidden sm:table-cell whitespace-nowrap">
                      {c.units === 0
                        ? <span className="text-[10px]">prije {fmtKm(c.prevRevenue)}</span>
                        : <Delta current={c.revenue} previous={c.prevRevenue} />}
                    </td>
                  )}
                  <td className="py-2.5 px-2 text-right tabular-nums hidden sm:table-cell">{fmtInt(c.units)}</td>
                  <td className="py-2.5 px-2 text-right tabular-nums hidden md:table-cell">{c.products}</td>
                  <td className="py-2.5 px-2 pr-3 text-right">{c.units > 0 ? <SellThroughBar value={c.str} /> : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Section>
  );
}
